import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21de63de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content-box"
};
const _hoisted_2 = {
  class: "contenBox"
};
const _hoisted_3 = {
  class: "contenTab"
};
const _hoisted_4 = {
  class: "contenSetion"
};
const _hoisted_5 = {
  class: "user-info-box"
};
const _hoisted_6 = {
  class: "user-info-item-title1"
};
const _hoisted_7 = {
  class: ""
};
const _hoisted_8 = {
  class: "avatarBox"
};
const _hoisted_9 = {
  class: "avatar184"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "184px", -1));
const _hoisted_12 = {
  class: "avatar64"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "64px", -1));
const _hoisted_15 = {
  class: "avatar32"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "32px", -1));
const _hoisted_18 = {
  class: "avatarTips"
};
const _hoisted_19 = {
  class: "user-info-item-title1"
};
const _hoisted_20 = {
  class: "user-info-item",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_21 = {
  class: "user-info-item-title"
};
const _hoisted_22 = {
  class: "user-info-item-content-box"
};
const _hoisted_23 = {
  key: 0,
  class: "user-info-item-content"
};
const _hoisted_24 = {
  class: "user-info-item",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_25 = {
  class: "user-info-item-title"
};
const _hoisted_26 = {
  class: "user-info-item-content-box"
};
const _hoisted_27 = {
  key: 0,
  class: "user-info-item-content"
};
const _hoisted_28 = {
  class: "bottomBtnBox"
};
const _hoisted_29 = {
  class: "contenSetion contenSetion2"
};
const _hoisted_30 = {
  class: "user-info-box",
  style: {
    "margin-top": "60px"
  }
};
const _hoisted_31 = {
  class: "user-info-item"
};
const _hoisted_32 = {
  class: "user-info-item-title"
};
const _hoisted_33 = {
  class: "user-info-item-content-box"
};
const _hoisted_34 = {
  class: "user-info-item-content"
};
const _hoisted_35 = {
  class: "user-info-item"
};
const _hoisted_36 = {
  class: "user-info-item-title"
};
const _hoisted_37 = {
  class: "user-info-item-content-box"
};
const _hoisted_38 = {
  key: 0,
  class: "user-info-item-content"
};
const _hoisted_39 = {
  class: "user-info-item"
};
const _hoisted_40 = {
  class: "user-info-item-title"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-info-item-content-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "user-info-item-content"
}, "********")], -1));
const _hoisted_42 = {
  class: "user-info-item"
};
const _hoisted_43 = {
  class: "user-info-item-title"
};
const _hoisted_44 = {
  class: "user-info-item-content-box user-info-item-content-box-grey"
};
const _hoisted_45 = {
  class: "user-info-item-content"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-info-item-modify"
}, null, -1));
const _hoisted_47 = {
  class: "user-info-item"
};
const _hoisted_48 = {
  class: "user-info-item-title"
};
const _hoisted_49 = {
  class: "user-info-item-content-box user-info-item-content-box-grey"
};
const _hoisted_50 = {
  class: "user-info-item-content"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-info-item-modify"
}, null, -1));
const _hoisted_52 = {
  class: "ex-dialog-title"
};
const _hoisted_53 = {
  class: "dialogBox"
};
const _hoisted_54 = {
  class: "dialogItem"
};
const _hoisted_55 = {
  class: "itemLable"
};
const _hoisted_56 = {
  class: "dialogItem"
};
const _hoisted_57 = {
  class: "itemLable"
};
const _hoisted_58 = {
  class: "dialogItem",
  style: {
    "display": "flex",
    "justify-content": "end"
  }
};
const _hoisted_59 = {
  class: "ex-dialog-title"
};
const _hoisted_60 = {
  class: "dialogBox"
};
const _hoisted_61 = {
  class: "dialogItem"
};
const _hoisted_62 = {
  class: "itemLable"
};
const _hoisted_63 = {
  class: "dialogItem"
};
const _hoisted_64 = {
  class: "itemLable"
};
const _hoisted_65 = {
  class: "dialogItem",
  style: {
    "display": "flex",
    "justify-content": "end"
  }
};
const _hoisted_66 = {
  class: "ex-dialog-title"
};
const _hoisted_67 = {
  class: "dialogBox"
};
const _hoisted_68 = {
  class: "dialogItem"
};
const _hoisted_69 = {
  class: "itemLable"
};
const _hoisted_70 = {
  class: "dialogItem"
};
const _hoisted_71 = {
  class: "itemLable"
};
const _hoisted_72 = {
  class: "dialogItem"
};
const _hoisted_73 = {
  class: "itemLable"
};
const _hoisted_74 = {
  class: "dialogItem",
  style: {
    "display": "flex",
    "justify-content": "end"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_input = _resolveComponent("a-input");
  const _component_el_input = _resolveComponent("el-input");
  const _component_a_divider = _resolveComponent("a-divider");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_form = _resolveComponent("a-form");
  const _component_ex_dialog = _resolveComponent("ex-dialog");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_Tailoring = _resolveComponent("Tailoring");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass({
      contenTabC: _ctx.contenTab === 1
    }),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.contenTab = 1)
  }, _toDisplayString(_ctx.$t("userModify.accountInfo")), 3), _createElementVNode("div", {
    class: _normalizeClass({
      contenTabC: _ctx.contenTab === 2
    }),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.contenTab = 2)
  }, _toDisplayString(_ctx.$t("userModify.securitySettings")), 3)]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("userModify.avatarSettings")) + ": ", 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createElementVNode("img", {
    class: "imgBorder",
    src: _ctx.userData.userModifyRo.avatar,
    alt: ""
  }, null, 8, _hoisted_10)]), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createElementVNode("img", {
    class: "imgBorder",
    src: _ctx.userData.userModifyRo.avatar,
    alt: ""
  }, null, 8, _hoisted_13)]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("img", {
    class: "imgBorder",
    src: _ctx.userData.userModifyRo.avatar,
    alt: ""
  }, null, 8, _hoisted_16)]), _hoisted_17])]), _createVNode(_component_a_button, {
    class: "sts-button default",
    style: {
      "width": "90px"
    },
    onClick: _cache[2] || (_cache[2] = $event => _ctx.userData.avatarDialogVisible = true)
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userModify.uploadAvatar")), 1)]),
    _: 1
  }), _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("userModify.avatarUploadTip")), 1)]), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("userModify.accountName")) + ": ", 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("userModify.lastName")) + ": ", 1), _createElementVNode("div", _hoisted_22, [_ctx.userData.lastNameEdit == false ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.userData.userModifyRo.lastName), 1)) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_a_input, {
    ref: "lastNameInput",
    value: _ctx.userData.userModifyRo.lastName,
    "onUpdate:value": _cache[3] || (_cache[3] = $event => _ctx.userData.userModifyRo.lastName = $event),
    placeholder: _ctx.$t('userModify.lastName'),
    style: {
      "flex": "1",
      "border": "none",
      "padding": "0 0 0 16px"
    }
  }, null, 8, ["value", "placeholder"]), [[_vShow, _ctx.userData.lastNameEdit == true]]), _createElementVNode("div", {
    style: {
      "margin-right": "15px",
      "cursor": "pointer"
    },
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.editLastNameClick && _ctx.editLastNameClick(...args))
  }, _toDisplayString(_ctx.$t("userModify.edit")), 1)])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("userModify.firstName")) + ": ", 1), _createElementVNode("div", _hoisted_26, [_ctx.userData.firstNameEdit == false ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.userData.userModifyRo.firstName), 1)) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_a_input, {
    ref: "firstNameInput",
    value: _ctx.userData.userModifyRo.firstName,
    "onUpdate:value": _cache[5] || (_cache[5] = $event => _ctx.userData.userModifyRo.firstName = $event),
    placeholder: _ctx.$t('userModify.enterFirstName'),
    style: {
      "flex": "1",
      "border": "none",
      "padding": "0 0 0 16px"
    }
  }, null, 8, ["value", "placeholder"]), [[_vShow, _ctx.userData.firstNameEdit == true]]), _createElementVNode("div", {
    style: {
      "margin-right": "15px",
      "cursor": "pointer"
    },
    onClick: _cache[6] || (_cache[6] = (...args) => _ctx.editFirstNameClick && _ctx.editFirstNameClick(...args))
  }, _toDisplayString(_ctx.$t("userModify.edit")), 1)])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_a_button, {
    onClick: _ctx.confirmSaveUser,
    class: "sts-button default"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.save")), 1)]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_a_button, {
    onClick: _ctx.cancelSaveUser,
    style: {
      "margin-left": "23px"
    },
    class: "sts-button default"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.cancel")), 1)]),
    _: 1
  }, 8, ["onClick"])])])], 512), [[_vShow, _ctx.contenTab === 1]]), _withDirectives(_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("userModify.mobile")), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.userData.userModifyRo.mobile), 1)]), _createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = (...args) => _ctx.editMobileClick && _ctx.editMobileClick(...args)),
    class: "user-info-item-modify"
  }, [_createVNode(_component_a_button, {
    style: {
      "margin-left": "20px"
    },
    class: "sts-button default"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userModify.edit")), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("userModify.email")), 1), _createElementVNode("div", _hoisted_37, [_ctx.userData.emailEdit == false ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.userData.userModifyRo.email), 1)) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_input, {
    ref: "emailInput",
    value: _ctx.userData.userModifyRo.email,
    "onUpdate:value": _cache[8] || (_cache[8] = $event => _ctx.userData.userModifyRo.email = $event),
    placeholder: _ctx.$t('userModify.enterEmail'),
    style: {
      "flex": "1"
    }
  }, null, 8, ["value", "placeholder"]), [[_vShow, _ctx.userData.emailEdit == true]])]), _createElementVNode("div", {
    onClick: _cache[9] || (_cache[9] = (...args) => _ctx.editEmailClick && _ctx.editEmailClick(...args)),
    class: "user-info-item-modify"
  }, [_createVNode(_component_a_button, {
    style: {
      "margin-left": "20px"
    },
    class: "sts-button default"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userModify.edit")), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("userModify.accountPassword")), 1), _hoisted_41, _createElementVNode("div", {
    onClick: _cache[10] || (_cache[10] = (...args) => _ctx.editPasswordClick && _ctx.editPasswordClick(...args)),
    class: "user-info-item-modify"
  }, [_createVNode(_component_a_button, {
    style: {
      "margin-left": "20px"
    },
    class: "sts-button default"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userModify.edit")), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("userModify.department")), 1), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.userData.userOrganization.organizationName), 1)]), _hoisted_46]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("userModify.role")), 1), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.userData.userOrganization.primaryAccount == 1 ? _ctx.$t("userModify.mainAccount") : _ctx.$t("userModify.subAccount")), 1)]), _hoisted_51])])], 512), [[_vShow, _ctx.contenTab === 2]]), _createVNode(_component_ex_dialog, {
    extraStyle: "width:100%;height:100%",
    isVisible: _ctx.userData.mobileDialogVisible
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("userModify.editMobile")), 1), _createVNode(_component_a_divider), _createVNode(_component_a_form, {
      ref: "mobileForm",
      inline: true,
      rules: _ctx.userData.mobileFormRules,
      model: _ctx.userData.mobileFormData,
      "label-width": "0px"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("userModify.newMobile")) + ":", 1), _createVNode(_component_a_form_item, {
        style: {
          "flex": "1"
        },
        name: "mobile"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          ref: "mobileInput",
          style: {
            "width": "300px",
            "height": "39px"
          },
          value: _ctx.userData.mobileFormData.mobile,
          "onUpdate:value": _cache[11] || (_cache[11] = $event => _ctx.userData.mobileFormData.mobile = $event),
          placeholder: _ctx.$t('userModify.enterMobile')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_56, [_createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("userModify.enterCode")) + ":", 1), _createVNode(_component_a_form_item, {
        style: {
          "flex": "1"
        },
        name: "smsCode"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          style: {
            "width": "200px",
            "height": "39px"
          },
          value: _ctx.userData.mobileFormData.smsCode,
          "onUpdate:value": _cache[12] || (_cache[12] = $event => _ctx.userData.mobileFormData.smsCode = $event),
          placeholder: _ctx.$t('userModify.enterCode')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }), _createVNode(_component_a_button, {
        disabled: _ctx.smsModifyControl.smsDisabled,
        onClick: _ctx.onSendModifySms,
        style: {
          "margin-left": "15px",
          "margin-top": "8px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.smsModifyControl.smsButtonText), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])]), _createElementVNode("div", _hoisted_58, [_createVNode(_component_a_button, {
        onClick: _ctx.confirmSaveMobile,
        style: {
          "margin-left": "15px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.save")), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        onClick: _cache[13] || (_cache[13] = $event => _ctx.userData.mobileDialogVisible = false),
        style: {
          "margin-left": "15px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.cancel")), 1)]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["rules", "model"])]),
    _: 1
  }, 8, ["isVisible"]), _createVNode(_component_ex_dialog, {
    extraStyle: "width:100%;height:100%",
    isVisible: _ctx.userData.emailDialogVisible
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("userModify.editEmail")), 1), _createVNode(_component_a_divider), _createVNode(_component_a_form, {
      ref: "emailForm",
      inline: true,
      rules: _ctx.userData.emailFormRules,
      model: _ctx.userData.emailFormData,
      "label-width": "0px"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t("userModify.newEmail")) + ":", 1), _createVNode(_component_a_form_item, {
        style: {
          "flex": "1"
        },
        name: "email"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          ref: "emailInput",
          style: {
            "width": "300px",
            "height": "39px"
          },
          value: _ctx.userData.emailFormData.email,
          "onUpdate:value": _cache[14] || (_cache[14] = $event => _ctx.userData.emailFormData.email = $event),
          placeholder: _ctx.$t('userModify.enterEmail')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_63, [_createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t("userModify.enterCode")) + ":", 1), _createVNode(_component_a_form_item, {
        style: {
          "flex": "1"
        },
        name: "emailCode"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          style: {
            "width": "200px",
            "height": "39px"
          },
          value: _ctx.userData.emailFormData.emailCode,
          "onUpdate:value": _cache[15] || (_cache[15] = $event => _ctx.userData.emailFormData.emailCode = $event),
          placeholder: _ctx.$t('userModify.enterCode')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }), _createVNode(_component_a_button, {
        disabled: _ctx.emailModifyControl.emailDisabled,
        onClick: _ctx.onSendModifyEmail,
        style: {
          "margin-left": "15px",
          "margin-top": "8px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.emailModifyControl.emailButtonText), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])]), _createElementVNode("div", _hoisted_65, [_createVNode(_component_a_button, {
        onClick: _ctx.confirmSaveEmail,
        style: {
          "margin-left": "15px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.save")), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        onClick: _cache[16] || (_cache[16] = $event => _ctx.userData.emailDialogVisible = false),
        style: {
          "margin-left": "15px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.cancel")), 1)]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["rules", "model"])]),
    _: 1
  }, 8, ["isVisible"]), _createVNode(_component_ex_dialog, {
    extraStyle: "width:100%;height:100%",
    isVisible: _ctx.userData.passwordDialogVisible
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t("userModify.editPassword")), 1), _createVNode(_component_el_divider), _createVNode(_component_a_form, {
      ref: "passwordForm",
      inline: true,
      rules: _ctx.userData.passwordFormRules,
      model: _ctx.userData.passwordFormData,
      "label-width": "0px"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t("userModify.oldPassword")) + ":", 1), _createVNode(_component_a_form_item, {
        style: {
          "flex": "1"
        },
        name: "oldPassword"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          type: "password",
          style: {
            "width": "300px",
            "height": "39px"
          },
          value: _ctx.userData.passwordFormData.oldPassword,
          "onUpdate:value": _cache[17] || (_cache[17] = $event => _ctx.userData.passwordFormData.oldPassword = $event),
          placeholder: _ctx.$t('userModify.enterOldPassword')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_70, [_createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("userModify.newPassword")) + ":", 1), _createVNode(_component_a_form_item, {
        style: {
          "flex": "1"
        },
        name: "password"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          style: {
            "width": "300px",
            "height": "39px"
          },
          value: _ctx.userData.passwordFormData.password,
          "onUpdate:value": _cache[18] || (_cache[18] = $event => _ctx.userData.passwordFormData.password = $event),
          placeholder: _ctx.$t('userModify.enterNewPassword')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_72, [_createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t("userModify.confirmPassword")) + ":", 1), _createVNode(_component_a_form_item, {
        style: {
          "flex": "1"
        },
        name: "passwordAgain"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          style: {
            "width": "300px",
            "height": "39px"
          },
          value: _ctx.userData.passwordFormData.passwordAgain,
          "onUpdate:value": _cache[19] || (_cache[19] = $event => _ctx.userData.passwordFormData.passwordAgain = $event),
          placeholder: _ctx.$t('userModify.reEnterPassword')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_74, [_createVNode(_component_a_button, {
        onClick: _ctx.confirmSavePassword,
        style: {
          "margin-left": "15px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.save")), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        onClick: _cache[20] || (_cache[20] = $event => _ctx.userData.passwordDialogVisible = false),
        style: {
          "margin-left": "15px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("userModify.cancel")), 1)]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["rules", "model"])]),
    _: 1
  }, 8, ["isVisible"])])]), _createVNode(_component_a_modal, {
    open: _ctx.userData.avatarDialogVisible,
    "onUpdate:open": _cache[21] || (_cache[21] = $event => _ctx.userData.avatarDialogVisible = $event),
    footer: null,
    title: _ctx.$t('userModify.editAvatar'),
    style: {
      "width": "514px",
      "height": "531px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_Tailoring, {
      onImgUrlbase64: _ctx.imgUrlbase64
    }, null, 8, ["onImgUrlbase64"])]),
    _: 1
  }, 8, ["open", "title"])], 64);
}